<template>
  <b-row>
    <b-col lg="12" class="bg-light mt-4 text-left py-3">
      <b-form class="w-100 d-inline-block" v-on:submit.prevent="handleUpdate">
        <h5>Этап 1. Идентификация</h5>
        <p class="text-sm-left">
          Показанные результаты KYC позволяют обновить всю информацию.
          <select v-model="riskLevel">
            <option value="1">risk level Низкий</option>
            <option value="2">risk level Средний</option>
            <option value="3">risk level Высокий</option>
          </select>
        </p>

        <b-form-row class="mt-3">
          <!-- Персональная информация -->
          <b-col sm="auto" lg="4" class="text-left pr-3">
            <b-form-row>
              <b-col lg="12" style="background: var(--Shade-2-30, #18191D);" class="rounded-sm">
                <h6 class="text-light pt-2">Персональная информация</h6>
              </b-col>

              <b-col lg="12">
                <label for="lastName" class="reg-label">{{$t('kycForm.lastName')}}</label>
                <input
                  id="lastName"
                  type="text"
                  class="w-100 p-2 form-control form-control-sm"
                  required
                  v-model="userForm.lastName"
                />
              </b-col>

              <b-col lg="12">
                <label for="firstName" class="reg-label">{{$t('kycForm.firstName')}}</label>
                <input
                  id="firstName"
                  type="text"
                  class="w-100 p-2 form-control form-control-sm"
                  required
                  v-model="userForm.firstName"
                />
              </b-col>

              <b-col lg="12">
                <label for="surName" class="reg-label">{{$t('kycForm.surName')}}</label>
                <input
                  id="surName"
                  type="text"
                  class="w-100 p-2 form-control form-control-sm"
                  v-model="userForm.surName"
                />
              </b-col>

              <b-col lg="12">
                <label for="birthDate" class="reg-label">{{$t('kycForm.birthDate')}}</label>
                <input
                  id="birthDate"
                  type="date"
                  class="w-100 p-2 form-control form-control-sm"
                  v-model="userForm.birthDate"
                />
              </b-col>

              <b-col lg="12">
                <label for="birthPlace" class="reg-label">{{$t('kycForm.birthPlace')}}</label>
                <select
                  id="birthPlace"
                  class="w-100 form-control form-control-sm"
                  v-model="userForm.birthPlace"
                >
                  <option value="">please select</option>
                  <option v-for="country in countries" :key="country.id" :value="country.code">
                    {{ country.nameRu }}
                  </option>
                </select>
              </b-col>

              <b-col lg="12">
                <label for="iin" class="reg-label">{{$t('kycForm.iin')}}</label>
                <input
                  id="iin"
                  type="text"
                  class="w-100 p-2 form-control form-control-sm"
                  v-model="userForm.iin"
                />
              </b-col>

              <b-col lg="12">
                <label for="citizen" class="reg-label">{{$t('kycForm.citizen')}}</label>
                <select
                  id="citizen"
                  class="w-100 form-control form-control-sm"
                  v-model="userForm.citizen"
                >
                  <option value="">please select</option>
                  <option v-for="country in countries" :key="country.id" :value="country.code">
                    {{ country.nameRu }}
                  </option>
                </select>
              </b-col>

              <b-col lg="12">
                <label for="gender" class="reg-label text-danger">Пол</label>
                <b-form-select
                  id="gender"
                  v-model="userForm.gender"
                  class="form-control form-control-sm"
                  :options="genderOptions"
                />
              </b-col>

              <b-col lg="12">
                <label for="isPep" class="reg-label">{{$t('kycForm.isPep')}}</label>
                <select
                  id="isPep"
                  class="w-100 form-control form-control-sm"
                  v-model="userForm.isPep"
                >
                  <option :value="0">{{ $t('kycForm.No') }}</option>
                  <option :value="1">{{ $t('kycForm.Yes') }}</option>
                </select>
              </b-col>
            </b-form-row>
          </b-col>

          <!-- Документ, удостоверяющий личность -->
          <b-col sm="auto" lg="4" class="text-left pr-3">
            <b-form-row>
              <b-col lg="12" style="background: var(--Shade-2-30, #18191D);" class="rounded-sm">
                <h6 class="text-light pt-2">Документ, удостоверяющий личность</h6>
              </b-col>

              <b-col lg="12">
                <label for="docTypeId" class="reg-label">{{$t('kycForm.docType')}}</label>
                <select
                  id="docTypeId"
                  class="w-100 form-control form-control-sm"
                  required
                  v-model="userForm.docTypeId"
                >
                  <option value="">please select</option>
                  <option
                    v-for="docType in docTypes"
                    :key="docType.docTypeId"
                    :value="docType.docTypeId"
                  >
                    {{ docType.nameRu }}
                  </option>
                </select>
              </b-col>

              <b-col lg="12">
                <label for="kycNumber" class="reg-label">{{$t('kycForm.kycNumber')}}</label>
                <input
                  id="kycNumber"
                  type="text"
                  class="w-100 p-2 form-control form-control-sm"
                  required
                  v-model="userForm.kycNumber"
                />
              </b-col>

              <b-col lg="12">
                <label for="kycSerial" class="reg-label">{{$t('kycForm.kycSerial')}}</label>
                <input
                  id="kycSerial"
                  type="text"
                  class="w-100 p-2 form-control form-control-sm"
                  required
                  v-model="userForm.kycSerial"
                />
              </b-col>

              <b-col lg="12">
                <label for="kycIssuedBy" class="reg-label">{{$t('kycForm.kycIssuedBy')}}</label>
                <input
                  id="kycIssuedBy"
                  type="text"
                  class="w-100 p-2 form-control form-control-sm"
                  v-model="userForm.kycIssuedBy"
                />
              </b-col>

              <b-col lg="12">
                <label for="kycGivenDate" class="reg-label">{{$t('kycForm.kycGivenDate')}}</label>
                <input
                  id="kycGivenDate"
                  type="date"
                  class="w-100 p-2 form-control form-control-sm"
                  v-model="userForm.kycGivenDate"
                />
              </b-col>

              <b-col lg="12">
                <label for="kycTillDate" class="reg-label">{{$t('kycForm.kycTillDate')}}</label>
                <input
                  id="kycTillDate"
                  type="date"
                  class="w-100 p-2 form-control form-control-sm"
                  v-model="userForm.kycTillDate"
                />
              </b-col>
            </b-form-row>
          </b-col>

          <!-- Резидентство, сектор экономики, ОКЭД, КБЕ -->
          <b-col sm="auto" lg="4" class="text-left">
            <b-form-row>
              <b-col lg="12" style="background: var(--Shade-2-30, #18191D);" class="rounded-sm">
                <h6 class="text-light pt-2">Резидентство, сектор экономики, ОКЭД и КБЕ</h6>
              </b-col>

              <b-col lg="12">
                <label for="residencySign" class="reg-label">Признак резидентства</label>
                <b-form-select
                  id="residencySign"
                  v-model="userForm.residencySign"
                  class="form-control form-control-sm"
                  :options="residencyOptions"
                />
              </b-col>

              <b-col lg="12">
                <label for="residencyCountry" class="reg-label">Страна резидентства</label>
                <select
                  id="residencyCountry"
                  class="w-100 form-control form-control-sm"
                  v-model="userForm.residencyCountry"
                >
                  <option value="">please select</option>
                  <option v-for="country in countries" :key="country.id" :value="country.code">
                    {{ country.nameRu }}
                  </option>
                </select>
              </b-col>

              <b-col lg="12">
                <label for="sectorEconomy" class="reg-label">{{$t('kycForm.sectorEconomy')}}</label>
                <select
                  id="sectorEconomy"
                  class="w-100 form-control form-control-sm"
                  v-model="userForm.sectorEconomy"
                >
                  <option value="">please select</option>
                  <option v-for="ec in economies" :key="ec.economyId" :value="ec.economyId">
                    {{ ec.nameRu }}
                  </option>
                </select>
              </b-col>

              <b-col lg="12">
                <label for="oked" class="reg-label">{{$t('kycForm.oked')}}</label>
                <select
                  id="oked"
                  class="w-100 form-control form-control-sm"
                  v-model="userForm.oked"
                >
                  <option value="">please select</option>
                  <option v-for="oked in okeds" :key="oked.okedId" :value="oked.okedId">
                    {{ oked.nameRu }}
                  </option>
                </select>
              </b-col>

              <b-col lg="12">
                <label for="kbe" class="reg-label">{{$t('kycForm.kbe')}}</label>
                <input
                  id="kbe"
                  type="text"
                  class="w-100 p-2 form-control form-control-sm"
                  v-model="userForm.kbe"
                />
              </b-col>
            </b-form-row>
          </b-col>

          <!-- Телефон/Email + PEP-теги справа -->
          <b-col sm="auto" lg="12" class="mt-3">
            <b-form-row>
              <!-- Left: email & phones -->
              <b-col lg="8">
                <b-col lg="12" style="background: var(--Shade-2-30, #18191D);" class="rounded-sm">
                  <h6 class="text-light pt-2">Электронный адрес и номер телефона</h6>
                </b-col>

                <b-col lg="12">
                  <label for="email" class="reg-label">Электронный адрес</label>
                  <input
                    id="email"
                    type="email"
                    class="w-100 p-2 form-control form-control-sm"
                    v-model="userForm.email"
                  />
                </b-col>

                <b-col lg="12">
                  <label for="phoneNumber" class="reg-label">Номер телефона</label>
                  <input
                    id="phoneNumber"
                    type="text"
                    class="w-100 p-2 form-control form-control-sm"
                    v-model="userForm.phoneNumber"
                  />
                </b-col>

                <b-col lg="12">
                  <label for="phoneNumberHome" class="reg-label">{{$t('kycForm.phoneNumberHome')}}</label>
                  <input
                    id="phoneNumberHome"
                    type="text"
                    class="w-100 p-2 form-control form-control-sm"
                    v-model="userForm.phoneNumberHome"
                  />
                </b-col>

                <b-col lg="12">
                  <label for="phoneNumberWork" class="reg-label">{{$t('kycForm.phoneNumberWork')}}</label>
                  <input
                    id="phoneNumberWork"
                    type="text"
                    class="w-100 p-2 form-control form-control-sm"
                    v-model="userForm.phoneNumberWork"
                  />
                </b-col>
              </b-col>

              <!-- Right: PEP tags -->
              <b-col lg="4">
                <b-col lg="12" style="background: var(--Shade-2-30, #18191D);" class="rounded-sm">
                  <h6 class="text-light pt-2">Причастность ПДЛ</h6>
                </b-col>

                <b-col lg="12">
                  <label for="pepTag" class="reg-label">Причастность ПДЛ</label>
                  <input
                    id="pepTag"
                    type="text"
                    class="w-100 p-2 form-control form-control-sm"
                    v-model="userForm.pepTagInvolvement"
                  />
                </b-col>

                <b-col lg="12">
                  <label for="pepTagSource" class="reg-label">Источник метки ПДЛ</label>
                  <input
                    id="pepTagSource"
                    type="text"
                    class="w-100 p-2 form-control form-control-sm"
                    v-model="userForm.pepTagSource"
                  />
                </b-col>
              </b-col>
            </b-form-row>
          </b-col>

          <!-- Информация о ПДЛ -->
          <b-col sm="auto" lg="12" class="mt-3" v-show="userForm.isPep == 1">
            <b-form-row>
              <b-col lg="12" style="background: var(--Shade-2-30, #18191D);" class="rounded-sm">
                <h6 class="text-light pt-2">Информация о ПДЛ</h6>
              </b-col>

              <b-col lg="4">
                <label for="pepFio" class="reg-label">ФИО ПДЛ</label>
                <input
                  id="pepFio"
                  type="text"
                  class="w-100 p-2 form-control form-control-sm"
                  v-model="userForm.pepFio"
                />
              </b-col>

              <b-col lg="4">
                <label for="pepPosition" class="reg-label">Должность ПДЛ</label>
                <input
                  id="pepPosition"
                  type="text"
                  class="w-100 p-2 form-control form-control-sm"
                  v-model="userForm.pepPosition"
                />
              </b-col>

              <b-col lg="4">
                <label for="pepRel" class="reg-label">Взаимосвязь</label>
                <input
                  id="pepRel"
                  type="text"
                  class="w-100 p-2 form-control form-control-sm"
                  v-model="userForm.pepRelDeg"
                />
              </b-col>
            </b-form-row>
          </b-col>

          <!-- Адрес место нахождения -->
          <b-col sm="auto" lg="12" class="mt-3">
            <b-form-row>
              <b-col lg="12" style="background: var(--Shade-2-30, #18191D);" class="rounded-sm">
                <h6 class="text-light pt-2">Адрес место нахождения</h6>
              </b-col>

              <b-col lg="6">
                <b-form-row>
                  <b-col lg="12">
                    <label for="realCountry" class="reg-label">Страна</label>
                    <select
                      id="realCountry"
                      class="w-100 form-control form-control-sm"
                      v-model="userForm.realCountry"
                    >
                      <option value="">please select</option>
                      <option v-for="country in countries" :key="country.id" :value="country.code">
                        {{ country.nameRu }}
                      </option>
                    </select>
                  </b-col>
                  <b-col lg="12">
                    <label for="realRegion" class="reg-label">Регион</label>
                    <input
                      id="realRegion"
                      type="text"
                      class="w-100 p-2 form-control form-control-sm"
                      v-model="userForm.realRegion"
                    />
                  </b-col>
                </b-form-row>
              </b-col>

              <b-col lg="6">
                <b-form-row>
                  <b-col lg="6">
                    <label for="realIndex" class="reg-label">Индекс</label>
                    <input
                      id="realIndex"
                      type="text"
                      class="w-100 p-2 form-control form-control-sm"
                      v-model="userForm.realIndex"
                    />
                  </b-col>
                  <b-col lg="6">
                    <label for="realCity" class="reg-label">Город, Населен. пункт</label>
                    <input
                      id="realCity"
                      type="text"
                      class="w-100 p-2 form-control form-control-sm"
                      v-model="userForm.realCity"
                    />
                  </b-col>
                  <b-col lg="12">
                    <label for="realAddr" class="reg-label">Адрес</label>
                    <input
                      id="realAddr"
                      type="text"
                      class="w-100 p-2 form-control form-control-sm"
                      v-model="userForm.realAddr"
                    />
                  </b-col>
                </b-form-row>
              </b-col>
            </b-form-row>
          </b-col>

          <!-- Адрес регистрации (всегда показываем) -->
          <b-col sm="auto" lg="12" class="mt-3">
            <b-form-row>
              <b-col lg="12" style="background: var(--Shade-2-30, #18191D);" class="rounded-sm">
                <h6 class="text-light pt-2">Адрес регистрации</h6>
              </b-col>

              <b-col lg="6">
                <b-form-row>
                  <b-col lg="12">
                    <label for="regCountry" class="reg-label">Страна</label>
                    <select
                      id="regCountry"
                      class="w-100 form-control form-control-sm"
                      v-model="userForm.regCountry"
                    >
                      <option value="">please select</option>
                      <option v-for="country in countries" :key="country.id" :value="country.code">
                        {{ country.nameRu }}
                      </option>
                    </select>
                  </b-col>
                  <b-col lg="12">
                    <label for="regRegion" class="reg-label">Регион</label>
                    <input
                      id="regRegion"
                      type="text"
                      class="w-100 p-2 form-control form-control-sm"
                      v-model="userForm.regRegion"
                    />
                  </b-col>
                </b-form-row>
              </b-col>

              <b-col lg="6">
                <b-form-row>
                  <b-col lg="6">
                    <label for="regIndex" class="reg-label">Индекс</label>
                    <input
                      id="regIndex"
                      type="text"
                      class="w-100 p-2 form-control form-control-sm"
                      v-model="userForm.regIndex"
                    />
                  </b-col>
                  <b-col lg="6">
                    <label for="regCity" class="reg-label">Город, Населен. пункт</label>
                    <input
                      id="regCity"
                      type="text"
                      class="w-100 p-2 form-control form-control-sm"
                      v-model="userForm.regCity"
                    />
                  </b-col>
                  <b-col lg="12">
                    <label for="regAddr" class="reg-label">Адрес</label>
                    <input
                      id="regAddr"
                      type="text"
                      class="w-100 p-2 form-control form-control-sm"
                      v-model="userForm.regAddr"
                    />
                  </b-col>
                </b-form-row>
              </b-col>
            </b-form-row>
          </b-col>

          <!-- Место работы, должность и источник финансирования -->
          <b-col sm="auto" lg="12" class="mt-3">
            <b-form-row>
              <b-col lg="12" style="background: var(--Shade-2-30, #18191D);" class="rounded-sm">
                <h6 class="text-light pt-2">Место работы, должность и источник финансирования</h6>
              </b-col>

              <b-col lg="6">
                <b-form-row>
                  <b-col lg="12">
                    <label for="jobAddr" class="reg-label">Место работы</label>
                    <input
                      id="jobAddr"
                      type="text"
                      class="w-100 p-2 form-control form-control-sm"
                      v-model="userForm.jobAddr"
                    />
                  </b-col>
                  <b-col lg="12">
                    <label for="jobTitle" class="reg-label">Должность</label>
                    <input
                      id="jobTitle"
                      type="text"
                      class="w-100 p-2 form-control form-control-sm"
                      v-model="userForm.jobTitle"
                    />
                  </b-col>
                  <b-col lg="12">
                    <label for="moneySource" class="reg-label text-danger">Источник происхождения денег</label>
                    <input
                      id="moneySource"
                      type="text"
                      class="w-100 p-2 form-control form-control-sm"
                      v-model="userForm.moneySource"
                    />
                  </b-col>
                  <b-col lg="12">
                    <label for="wealthSource" class="reg-label text-danger">Источник богатства</label>
                    <input
                      id="wealthSource"
                      type="text"
                      class="w-100 p-2 form-control form-control-sm"
                      v-model="userForm.wealthSource"
                    />
                  </b-col>
                </b-form-row>
              </b-col>

              <b-col lg="6">
                <b-form-row>
                  <b-col lg="12">
                    <label for="jobBusinessPurpose" class="reg-label">Цель деловых отношений</label>
                    <input
                      id="jobBusinessPurpose"
                      type="text"
                      class="w-100 p-2 form-control form-control-sm"
                      v-model="userForm.jobBusinessPurpose"
                    />
                  </b-col>

                  <b-col lg="12">
                    <label for="jobBusiness" class="reg-label">Характер деловых отношений</label>
                    <b-form-select
                      id="jobBusiness"
                      v-model="userForm.jobBusiness"
                      class="form-control form-control-sm"
                      :options="businessCharacterOptions"
                    />
                  </b-col>

                  <b-col lg="12" v-if="userForm.jobBusiness==='6'">
                    <label for="jobBusinessOther" class="reg-label">Иное (уточните)</label>
                    <input
                      id="jobBusinessOther"
                      type="text"
                      class="w-100 p-2 form-control form-control-sm"
                      v-model="userForm.jobBusinessPurpose"
                    />
                  </b-col>
                </b-form-row>
              </b-col>
            </b-form-row>
          </b-col>

          <!-- Кнопки подтверждения/исправления -->
          <b-col lg="6" class="pl-0 ml-0 pt-4">
            <b-button @click="showConfirmToast()" block variant="outline-success">
              Подтвердить правильность данных
            </b-button>
          </b-col>
          <b-col lg="6" class="pt-4">
            <b-button @click="openFixModal()" block variant="outline-warning">
              Сообщить об ошибке данных
            </b-button>
          </b-col>

          <!-- Загрузки документов -->
          <b-col lg="12" class="pt-5">
            <b-form-row>
              <b-col lg="12" style="background: var(--Shade-2-30, #18191D);" class="rounded-sm">
                <h6 class="text-light pt-2">Документ, подтверждающий личность</h6>
              </b-col>
              <b-col lg="6" class="pl-0 pt-3">
                <b-form-file
                  browse-text="Выберите файл"
                  class="ml-0"
                  v-model="userForm.userFileId"
                  button-variant="outline-secondary"
                  placeholder="No file selected"
                  drop-placeholder="Drop file here..."
                ></b-form-file>
              </b-col>
            </b-form-row>
          </b-col>

          <b-col lg="12" class="pt-5">
            <b-form-row>
              <b-col lg="12" style="background: var(--Shade-2-30, #18191D);" class="rounded-sm">
                <h6 class="text-light pt-2">Документ, подтверждающий адрес место нахождения</h6>
              </b-col>
              <b-col lg="6" class="pl-0 pt-3">
                <b-form-file
                  browse-text="Выберите файл"
                  class="ml-0"
                  v-model="userForm.userFileRealAddr"
                  button-variant="outline-secondary"
                  placeholder="No file selected"
                  drop-placeholder="Drop file here..."
                ></b-form-file>
              </b-col>
            </b-form-row>
          </b-col>

          <b-col lg="12" class="pt-5">
            <b-form-row>
              <b-col lg="12" style="background: var(--Shade-2-30, #18191D);" class="rounded-sm">
                <h6 class="text-light pt-2">Документ, подтверждающий адрес регистрации</h6>
              </b-col>
              <b-col lg="6" class="pl-0 pt-3">
                <b-form-file
                  browse-text="Выберите файл"
                  class="ml-0"
                  v-model="userForm.userFileRegAddr"
                  button-variant="outline-secondary"
                  placeholder="No file selected"
                  drop-placeholder="Drop file here..."
                ></b-form-file>
              </b-col>
            </b-form-row>
          </b-col>
        </b-form-row>

        <hr class="mt-4 mb-3" />
        <h5>Этап 2. Увеличение лимита</h5>
        <p class="text-sm-left">
          Пожалуйста, пройдите тестирование и приложите документ, подтверждающий источник происхождения денег.
        </p>
        <b-col lg="12" class="pb-5 pt-2 pl-0">
          <b-form-row>
            <b-col lg="6" class="pl-0">
              <b-button type="submit" block variant="outline-secondary" @click="handleUpdate">
                <b-icon icon="pencil-square"></b-icon> Увеличить лимит
              </b-button>
            </b-col>
          </b-form-row>
        </b-col>

        <hr class="mt-4 mb-3" />
        <h5>Этап 3. Изменение классификации клиента</h5>
        <p class="text-sm-left">
          Пожалуйста, если хотите изменить свою классификацию нажмите нижеуказанную кнопку.
        </p>
        <b-col lg="12" class="pb-5 pt-2 pl-0">
          <b-form-row>
            <b-col lg="6" class="pl-0">
              <b-button type="submit" block variant="outline-secondary" @click="handleUpdate">
                <b-icon icon="pencil-square"></b-icon> Изменить классификацию
              </b-button>
            </b-col>
          </b-form-row>
        </b-col>
      </b-form>
    </b-col>

    <!-- Modal: Запрос на исправление информации -->
    <b-modal
      id="request-fix-modal"
      ref="requestFixModal"
      centered
      size="lg"
      hide-footer
      content-class="border-0 rounded-lg shadow-lg"
      header-bg-variant="dark"
      header-text-variant="light"
      body-class="py-3"
    >
      <template #modal-title>
        <div class="d-flex align-items-center">
          <b-icon icon="pencil-square" class="mr-2" />
          <span>Запрос на исправление информации</span>
        </div>
      </template>

      <b-form-group
        label="Укажите информацию, которую необходимо исправить."
        label-for="fix-textarea"
        label-class="font-weight-semibold"
      >
        <b-form-textarea
          id="fix-textarea"
          v-model.trim="fixText"
          rows="5"
          max-rows="9"
          :maxlength="2000"
          placeholder="Опишите, какие данные нужно исправить…"
          class="shadow-sm"
        />
        <small class="text-muted d-block mt-2">
          Пожалуйста, укажите точные поля и корректные значения.
        </small>
      </b-form-group>

      <div class="d-flex justify-content-end mt-3">
        <b-button variant="success" class="mr-2 shadow-sm" @click="sendFixRequest" :disabled="!fixText">
          <b-icon icon="send" class="mr-1" />
          Отправить
        </b-button>
        <b-button variant="outline-secondary" class="shadow-sm" @click="clearAndClose">
          <b-icon icon="x-circle" class="mr-1" />
          Очистить
        </b-button>
      </div>
    </b-modal>
  </b-row>
</template>

<script>
import axios from 'axios'
import { apiDomain, getHeader } from '@/config/config'

export default {
  name: 'Profile',
  data() {
    return {
      fixText: '',
      riskLevel: 0,
      showModal: false,

      // OPTIONS
      genderOptions: [
        { value: '', text: 'please select' },
        { value: 'M', text: 'Мужской' },
        { value: 'F', text: 'Женский' }
      ],
      residencyOptions: [
        { value: '', text: 'please select' },
        { value: 'resident', text: 'Резидент' },
        { value: 'non_resident', text: 'Нерезидент' }
      ],
      businessCharacterOptions: [
        { value: '1', text: 'Разовая операция' },
        { value: '2', text: 'Регулярное сотрудничество' },
        { value: '3', text: 'Пассивное хранение активов' },
        { value: '4', text: 'Долгосрочные инвестиции' },
        { value: '5', text: 'Высокочастотные транзакции' },
        { value: '6', text: 'Иное' }
      ],

      countries: [],
      docTypes: [],
      economies: [
        { economyId: 1, nameRu: 'Сельское хозяйство' },
        { economyId: 2, nameRu: 'Промышленность' },
        { economyId: 3, nameRu: 'Строительство' },
        { economyId: 4, nameRu: 'Торговля' },
        { economyId: 5, nameRu: 'Услуги' },
        { economyId: 6, nameRu: 'Финансовый сектор' }
      ],
      okeds: [
        { okedId: 1, nameRu: 'ОКЭД 01 - Сельское хозяйство' },
        { okedId: 2, nameRu: 'ОКЭД 02 - Рыболовство' },
        { okedId: 3, nameRu: 'ОКЭД 03 - Лесное хозяйство' },
        { okedId: 4, nameRu: 'ОКЭД 05 - Горнодобывающая промышленность' },
        { okedId: 5, nameRu: 'ОКЭД 06 - Обрабатывающая промышленность' },
        { okedId: 6, nameRu: 'ОКЭД 07 - Электричество, газ и пароснабжение' }
      ],

      // MAIN FORM MODEL
      userForm: {
        // Personal
        lastName: '',
        firstName: '',
        surName: '',
        birthDate: '',
        birthPlace: '',
        iin: '',
        citizen: '',
        gender: '',
        isPep: 0,

        // Identity document
        docTypeId: '',
        kycNumber: '',
        kycSerial: '',
        kycIssuedBy: '',
        kycGivenDate: '',
        kycTillDate: '',

        // Residency & economy
        residencySign: '',
        residencyCountry: '',
        sectorEconomy: '',
        oked: '',
        kbe: '',

        // Contacts
        email: '',
        phoneNumber: '',
        phoneNumberHome: '',
        phoneNumberWork: '',

        // PEP tags near contacts
        pepTagInvolvement: '',
        pepTagSource: '',

        // PEP info (visible if isPep == 1)
        pepFio: '',
        pepPosition: '',
        pepRelDeg: '',

        // Real (current) address
        realCountry: '',
        realRegion: '',
        realIndex: '',
        realCity: '',
        realAddr: '',

        // Registration address
        regCountry: '',
        regRegion: '',
        regIndex: '',
        regCity: '',
        regAddr: '',

        // Job/Finance
        jobAddr: '',
        jobTitle: '',
        jobBusinessPurpose: '', // Цель деловых отношений / уточнение
        jobBusiness: '',        // Характер деловых отношений (select)
        moneySource: '',        // Источник происхождения денег
        wealthSource: '',       // Источник богатства

        // Files
        userFileId: null,        // ID doc
        userFileRealAddr: null,  // proof of real address
        userFileRegAddr: null    // proof of reg address
      }
    }
  },
  methods: {
    openFixModal() {
      this.$bvModal.show('request-fix-modal')
    },
    sendFixRequest() {
      this.showSuccessToast('Ваш запрос успешно отправлен.')
      this.fixText = ''
      this.$bvModal.hide('request-fix-modal')
    },
    clearAndClose() {
      this.fixText = ''
      this.$bvModal.hide('request-fix-modal')
    },
    showSuccessToast(message) {
      const h = this.$createElement
      const title = h('div', { class: 'd-flex align-items-center' }, [
        h('b-icon', { props: { icon: 'check-circle-fill' }, class: 'mr-2' }),
        h('strong', 'Готово')
      ])
      this.$bvToast.toast(message, {
        title,
        toaster: 'b-toaster-top-center',
        variant: 'success',
        solid: true,
        autoHideDelay: 3500,
        appendToast: true,
        toastClass: 'shadow-lg border-0 rounded-lg',
        bodyClass: 'py-2'
      })
    },
    showConfirmToast() {
      const h = this.$createElement
      const title = h('div', { class: 'd-flex align-items-center' }, [
        h('b-icon', { props: { icon: 'check-circle-fill' }, class: 'mr-2' }),
        h('strong', 'Подтверждено')
      ])
      this.$bvToast.toast('Вы подтвердили, что вся предоставленная вами информация верна.', {
        title,
        toaster: 'b-toaster-top-center',
        variant: 'success',
        solid: true,
        autoHideDelay: 4500,
        appendToast: true,
        toastClass: 'shadow-lg border-0 rounded-lg',
        bodyClass: 'py-2',
        noCloseButton: false
      })
    },
    handleUpdate() {
      alert('this is the case')
    },
    listDocTypes() {
      axios
        .get(apiDomain + '/exchange/doc/list', {
          headers: getHeader()
        })
        .then(response => {
          this.docTypes = response.data
        })
        .catch(error => {
          console.error('There was an error fetching the document types:', error)
        })
    },
    listCountries() {
      axios
        .get(apiDomain + '/exchange/country/list', {
          headers: getHeader()
        })
        .then(response => {
          this.countries = response.data
        })
        .catch(error => {
          console.error('There was an error fetching the countries:', error)
        })
    }
  },
  created() {
    this.listCountries()
    this.listDocTypes()
  }
}
</script>
